import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Button from '../ui/Button';
import Container from '../ui/Container';

export default function HeroSection() {
  return (
    <section className="relative h-[600px] flex items-center overflow-hidden">
      <motion.div 
        initial={{ scale: 1.1, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        className="absolute inset-0 z-0"
      >
        <img
          src="https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?auto=format&fit=crop&w=2000&q=80"
          alt="African landscape"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/50"></div>
      </motion.div>
      
      <Container>
        <div className="relative z-10 text-white max-w-3xl">
          <motion.h1 
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="text-5xl md:text-7xl font-bold mb-6 leading-tight"
          >
            Building Africa's Future
          </motion.h1>
          <motion.p 
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.7 }}
            className="text-xl md:text-2xl mb-8 leading-relaxed opacity-90"
          >
            Driving innovation, empowerment, and sustainable growth across multiple sectors in Ghana and beyond.
          </motion.p>
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.9 }}
          >
            <Link to="/about">
              <Button 
                variant="primary" 
                withArrow 
                className="text-lg px-8 py-4 shadow-xl hover:shadow-2xl transform hover:-translate-y-0.5 transition-all"
              >
                Learn More
              </Button>
            </Link>
          </motion.div>
        </div>
      </Container>
    </section>
  );
}